<!-- //
table的排序组件
@author xuyd
@date 2024-5-2
//-->
<template>
  <div>
    <span class="sortable-icon" @click="handleSort(scope.column)">
      <!-- 降序 -->
      <i :style="{color: isDescSort?  '#FF00FF' : ''}"
         :class="['el-icon-sort-down', {'is-active': scope.column.order}]"/>
      <!-- 升序 -->
      <i :style="{color: isAscSort?  '#FF00FF' : ''}"
         :class="['el-icon-sort-up', {'is-active': scope.column.order}]"/>
    </span>
  </div>
</template>
<script>

export default {
  name: 'CompSortableIcon',
  data() {
    return {
      isDescSort: null,
      isAscSort: null,
    };
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    scope: Object,
    sortParams: {
      type: Object,
      default: () => {
        return {
          orderByColumn: null,
          isAsc: null,
        }
      }
    },
  },
  watch: {
    sortParams: {
      handler(val) {
        this.isAscSort = (this.sortParams.orderByColumn === this.scope.column.property && this.sortParams.isAsc === true);
        this.isDescSort = (this.sortParams.orderByColumn === this.scope.column.property && this.sortParams.isAsc === false);
        if (this.sortParams.orderByColumn !== this.scope.column.property) {
          this.scope.column.order = '';
        }
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    /**
     * 排序
     */
    handleSort(column) {
      let prop = column.property;
      //console,log("===handleSort===",JSON.stringify(column))
      if (column.order === 'ascending') {
        column.order = 'descending';
      } else if (column.order === 'descending') {
        column.order = '';
      } else {
        column.order = 'ascending';
      }
      let order = column.order;
      this.$emit('change', {order: order, prop: prop});
    },
  }
}
</script>

<style lang="less" scoped>
.sortable-icon {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-direction: row;
  height: 24px;
  margin-left: 3px;
  cursor: pointer;

  i {
    font-weight: 750;
  }

  i.el-icon-sort-up {
    margin-left: -6px;
  }
}
</style>
